import { useFormikContext } from 'formik';
import { GipReportValues } from '../../types';
import { LoadOrderParamsBtn, MVS_CUSTOM_FIELD_ORDER_ID } from '../orders/LoadOrderParamsBtn';

export function LoadOrderParamsFromCustomField() {
  const { values } = useFormikContext<GipReportValues>();

  const allowLoad =
    values.customFieldKey?.name === MVS_CUSTOM_FIELD_ORDER_ID && !!values.customFieldValue;

  if (!allowLoad) {
    return null;
  }

  return <LoadOrderParamsBtn ordersIds={[values.customFieldValue]} />;
}
